import React from "react";

import { shareEnabled } from "../../config";
import GridItem from "../../partials/gridItem";
import ListItem from "../../partials/listItem";
import FavouriteBtn from "../../partials/favouriteBtn";
import { useWindowSize } from "../../partials/windowSize";
import { logCustomEvent } from "../../core/analytics";
import ShareBtn from "../../partials/shareBtn";

import { Col } from "react-bootstrap";
import { Button } from "@mui/material";
import OpenNewIcon from "@mui/icons-material/OpenInNewOutlined";
import { serverUrl } from "../../config";

export default function DocumentItem(props) {
  const { width } = useWindowSize();

  let listItem = {
    id: props.item?.nid,
    title: props.item?.title,
    category_label: props.item?.category_labels,
    className: "document",
  };

  console.log('props.item?.title', props.item?.title)

  return (
    <>
      {props.gridView && (
        <GridItem
          xs={12}
          md={3}
          itemClass="document"
          bundle={props.item?.bundle}
          title={props.item?.title}
          field_body={props.item?.summary || props.item?.body}
          cardActionArea={true}
          cardActionCallBack={() => {
            // navigate(`/documents/${props.item?.nid}`)
            if (props.item?.field_document) {
              window.open(serverUrl + props.item?.field_document, "_blank");
            }
          }}
          cardActions={true}
          category_label={props.item?.category_labels}
        >
          {shareEnabled && (
            <ShareBtn
              className="share-col ps-0"
              id={props.item?.nid}
              contentType={props.contentType}
              title={props.item?.title}
              route={"documents"}
              field_access_token={props.item.field_access_token}
              sharePrompt={`This is a public link that enables you to share the document with your client, no login required.`}
            />
          )}
          <Col xs={"auto"} className="d-flex align-items-center">
            <Button
              variant="screenItemBtn"
              mode="default"
              onClick={() => {
                if (props.item?.field_document) {
                  window.open(serverUrl + props.item?.field_document, "_blank");
                  logCustomEvent("read", props.item, "Document");
                }
                // window.open(serverUrl + props.item?.uri, '_blank')
                // navigate(`/documents/${props.item?.nid}`)
              }}
            >
              <OpenNewIcon sx={{ fontSize: "0.9rem" }} />
            </Button>
          </Col>
          <FavouriteBtn
            id={props.item.nid}
            contentType={props.contentType}
            mode={"default"}
          />
        </GridItem>
      )}
      {!props.gridView && (
        <ListItem
          active={props.activeDetail === props.item?.nid}
          owner="client"
          item={listItem}
          idEnabled={width < 576 ? false : true}
          categoryEnabled={width < 768 ? false : true}
          category_label={props.item?.category_labels}
          infoBtn
          handleInfo={() => props.setActiveDetails(props.item?.nid)}
          infoDisabled={!props.item?.summary && !props.item?.body}
          openBtn
          openBtnDisabled={!props.item?.field_document}
          handleOpen={() => {
            if (props.item?.field_document) {
              window.open(serverUrl + props.item?.field_document, "_blank");
              logCustomEvent("read", props.item, "Document");
            }
          }}
          title={props.item?.title}
          accordInfo
          accordInfoBody={props.item?.summary || props.item?.body}
          contentType={props.contentType}
          shareLink={
            props.item.access_token
              ? `${window.location.origin}/documents/${props.item?.nid}?hash=${props.item.access_token}`
              : "share link not available"
          }
          sharePrompt={`This is a public link that enables you to share the document with your client, no login required.`}
        ></ListItem>
      )}
    </>
  );
}
